import React from 'react';
import moment from 'moment';

function ViewTodoList({ TodoData }) {
  const todo = TodoData || {};

  return (
    <div className="text-left px-2 pb-0">
      <ul className="list-unstyled mb-0">
        <li className="mb-2"><b>Title :</b> {todo.Title || '-'}</li>
        <li className="mb-2"><b>Description :</b> {todo.Description || '-'}</li>
        <li className="mb-2"><b>Due Date :</b> {todo.DueDate ? moment(todo.DueDate).format('DD MMM YYYY, hh:mm A') : '-'}</li>
        <li className="mb-0"><b>Scheduled :</b> {Number(todo.IsScheduled) === 1 ? 'Yes' : 'No'}</li>
      </ul>
    </div>
  );
}

export default ViewTodoList;
